import { listArticles } from '../../request/backendApi/article/getArticles';
import { RuntimeClientAtom } from '../../runtime/RuntimeClient';
import * as Atom from 'effect/unstable/reactivity/Atom';
import { tagged } from '../../data/util/tagged';

// Define a Data.tagged type for type-safe atom keys with Equal implementation
type FetchArticlesPageKey = {
  readonly _tag: 'FetchArticlesPageKey';
  readonly page: number;
  readonly itemsPerPage: number;
  readonly section: string | undefined;
  readonly categoryId: string | undefined;
  readonly authorId: number | undefined;
};

const FetchArticlesPageKey = tagged<FetchArticlesPageKey>('FetchArticlesPageKey');

const fetchArticlesPageAtomFamily = Atom.family((key: FetchArticlesPageKey) => {
  return RuntimeClientAtom.atom(
    listArticles(key.page, key.itemsPerPage, key.section, key.categoryId, key.authorId)
  ).pipe(Atom.keepAlive);
});

export const fetchArticlesPageAtom = (
  page: number,
  itemsPerPage: number,
  section: string | undefined,
  categoryId: string | undefined,
  authorId: number | undefined
) => {
  const key = FetchArticlesPageKey({ page, itemsPerPage, section, categoryId, authorId });
  return fetchArticlesPageAtomFamily(key);
};
